exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-holder[data-v-956156dc] {\n  width: 100%;\n}\n.button-holder button[data-v-956156dc] {\n    margin-bottom: 20px;\n}\n.contain-pictures[data-v-956156dc] {\n  display: flex;\n}\n", ""]);

// exports
